class NativeReviewsArea extends HTMLElement {
  constructor() {
    super();

    const p = this.querySelector('[js-load-full-list]');

    if(p) {

      this.querySelector('[js-load-full-list]').addEventListener('click', e => {
        const t = e.currentTarget;
        t.classList.add('visually-hidden');
        this.querySelector('[js-paginated-list]').classList.add('visually-hidden');
        this.querySelector('[js-full-list]').classList.remove('visually-hidden');
      })

    }

  }

  hydrate(f) {

    switch (f) {
      case '5-stars':
      case '4-stars':
      case '3-stars':
      case '2-stars':
      case '1-star':
        this.removeInitialResults();
        this.removeHiddenItems();
        this.filterHideApartFrom(parseInt(f[0]));
        break;

      case 'most-recent':
        this.removeInitialResults();
        this.removeHiddenItems();
        this.sortByDate('desc');
        break;

      case 'oldest-first':
        this.removeInitialResults();
        this.removeHiddenItems();
        this.sortByDate('asc');
        break;

      default:
        break;
    }
  }


  removeInitialResults() {
    this.querySelector('[js-load-full-list]').classList.add('visually-hidden');
    this.querySelector('[js-full-list]').classList.remove('visually-hidden');
  }

  removeHiddenItems() {
    this.querySelectorAll(`.native-ratings-reviews__review-item`).forEach((el) => {
      el.classList.remove('visually-hidden');
    });
  }

  filterHideApartFrom(n) {
    this.querySelectorAll(`.native-ratings-reviews__review-item:not([data-stars="${n}"])`).forEach((el) => {
      el.classList.add('visually-hidden');
    });
  }

  sortByDate(direction = 'desc') {
    const items = Array.from(this.querySelectorAll('.native-ratings-reviews__review-item'));

    items.sort((a, b) => {
      const dateA = new Date(a.dataset.createdAt).getTime();
      const dateB = new Date(b.dataset.createdAt).getTime();

      return direction === 'asc' ? dateA - dateB : dateB - dateA;
    });

    items.forEach((el, index) => {
      el.style.order = index;
    });
  }
}

customElements.define('native-reviews-area', NativeReviewsArea);




class NativeReviewsContent extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[js-toggle]').addEventListener('click', e => {

      const target = e.currentTarget;

      this.querySelector('[js-truncate]').classList.toggle('visually-hidden');
      this.querySelector('[js-clip]').classList.toggle('visually-hidden');

      if (target.innerHTML == "Read more") {
        target.innerHTML = "Read less";
        target.classList.add('visually-hidden');
      } else {
        target.innerHTML = "Read more";
      }
    })
  }
}

customElements.define('native-review-content', NativeReviewsContent);


class NativeReviewsModal extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[js-close]').addEventListener('click', () => {
      this.close();
    })

    this.addEventListener('click', (e) => {
      const t = e.target;
      if(t.classList.contains('native-ratings-reviews__modal')) {
        this.close();
      }
    })
  }

  init(c, s, d, r, i) {


    const starSvg = (filled = true) => `
  <svg width="21" height="21" viewBox="0 0 21 21" fill="${filled ? '#F9B754' : 'none'}">
    <path
      d="M8.36209 8.45391H8.54394L8.59994 8.2809L10.7703 1.57616L12.9407 8.2809L12.9967 8.45391H13.1785H20.2028L14.519 12.5959L14.3725 12.7026L14.4284 12.875L16.5991 19.5735L10.9175 15.4331L10.7703 15.3258L10.6231 15.4331L4.94149 19.5735L7.11225 12.875L7.16811 12.7026L7.02166 12.5959L1.33786 8.45391H8.36209Z"
      stroke="#F9B754"
      stroke-width="0.5"
    />
  </svg>
`;


const renderStars = (rating) => {
  const filled = Number(rating);

  return `
    <span>
      ${Array.from({ length: 5 }, (_, i) =>
        starSvg(i < filled)
      ).join('')}
    </span>
  `;
};


    const stars = renderStars(s);
    this.querySelector('[js-inject-image]').innerHTML = `<img src="${i}" />`;
    this.querySelector('[js-inject-stars]').innerHTML = `${stars}`;
    this.querySelector('[js-inject-customer]').innerHTML = `${c}`;
    this.querySelector('[js-inject-date]').innerHTML = `${d}`;
    this.querySelector('[js-inject-date-mobile]').innerHTML = `${d}`;
    this.querySelector('[js-inject-content]').innerHTML = `${r}`;
    setTimeout(()=> {
      this.open();
    },200)

  }

  open() {
    this.classList.remove('closed');
    this.querySelector('[js-modal-inner]').classList.remove('closed');
  }

  close() {
    this.classList.add('closed');
    this.querySelector('[js-modal-inner]').classList.add('closed');

  }


}

customElements.define('native-reviews-modal', NativeReviewsModal);


class NativeReviewsMedia extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', e => {
      const targetModal = document.querySelector('native-reviews-modal');
      if (targetModal instanceof NativeReviewsModal) {
        targetModal.init(
          this.getAttribute('data-customer'),
          this.getAttribute('data-stars'),
          this.getAttribute('data-created-at'),
          this.getAttribute('data-content'),
          this.getAttribute('data-image')
        );
      } else {
        console.warn('NativeReviewsModal not found or not upgraded yet');
      }

    })

  }
}

customElements.define('native-review-media', NativeReviewsMedia);



class NativeReviewsFilters extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('.custom-dropdown__trigger');
    this.menuItems = this.querySelectorAll('.custom-dropdown__menu li');

    this._bindEvents();
  }

  _bindEvents() {
    if (!this.trigger || this.menuItems.length === 0) return;

    this.trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = this.classList.toggle('open');
      this.trigger.setAttribute('aria-expanded', isOpen);
    });

    this.menuItems.forEach(item => {
      item.addEventListener('click', (e) => {
        e.stopPropagation();
    
        const labelContainer = this.trigger.querySelector('div');
        const arrow = labelContainer.querySelector('.custom-dropdown__arrow');
    
        // Update text safely without killing the menu
        labelContainer.firstChild.textContent = item.textContent + ' ';
    
        this.classList.remove('open');
        this.trigger.setAttribute('aria-expanded', 'false');
    
        const reviewsArea = this.closest('native-reviews-area');
        if (reviewsArea instanceof NativeReviewsArea) {
          reviewsArea.hydrate(item.dataset.value);
        }

        this.menuItems.forEach(li => {
          if (li === item) {
            li.style.opacity = 0.5;
            li.style.pointerEvents = 'none';
          } else {
            li.style.opacity = 1;
            li.style.pointerEvents = 'auto';
          }
        });
    
        this.dispatchEvent(new CustomEvent('filterChange', {
          detail: { value: item.dataset.value },
          bubbles: true
        }));
      });
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.classList.remove('open');
        this.trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }
}

customElements.define('native-reviews-filters', NativeReviewsFilters);
